import React from 'react'
import VideoLength from '../shared/VideoLength';
import { Link } from 'react-router-dom';
import { abbreviateNumber } from 'js-abbreviation-number';



const SuggestionVideoCard = ({item}) => {
  return (
    <Link to={`/video/${item?.video?.videoId}`}>
      <div className='flex items-center mt-4'>
        <div className='w-[35%]'>
          <img src={item?.video?.thumbnails?.[0]?.url} className='w-[100%] md:rounded-xl' alt="Suggestion_video" />
        </div>
        <div className='w-[65%] ml-3'>
          <h1 className='text-sm font-bold text-white line-clamp-2'>{item?.video?.title}</h1>
          <p className='text-white/[0.6] text-sm'>{item?.video?.author?.title}</p>
          <span className='text-white/[0.6] text-sm'>{`${abbreviateNumber(item?.video?.stats?.views, 2)} Views • ${item?.video?.publishedTimeText}`}</span>
        </div>
      </div>
    </Link>
  )
}

export default SuggestionVideoCard
 